import { useESign } from '../eSignApplicationContext.jsx';
import { termsLabelList, termTextList, termsLinkList } from '../../../consts/terms.js';
import styled from 'styled-components';
import TextUtil from 'utils/TextUtil.js';
import MyColor from 'utils/MyColor.js';

// TODO: mobile pc 하나로 합치기
export default function ESignAgreementItem({ index, isMobile }) {
  const { checkedList, toggleChecked } = useESign();

  const CheckboxWrap = () => {
    if (isMobile) {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 15,
            cursor: 'pointer',
          }}
          onClick={() => toggleChecked(index)}
        >
          <img
            src={checkedList[index] ? '/icons/checked_box.png' : '/icons/unchecked_box.png'}
            alt="checkbox"
            width={18}
            height={18}
          />
          <StyledLabel>{termsLabelList[index]}</StyledLabel>
          <a href={termsLinkList[index]} style={{ padding: 8 }}>
            <img src="/icons/arrow_right_gray.png" alt="arrow" width={24} height={24} />
          </a>
        </div>
      );
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 8,
          flex: 1,
          cursor: 'pointer',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <StyledLabel>{termsLabelList[index]}</StyledLabel>
          <a href={termsLinkList[index]} style={{ cursor: 'pointer' }}>
            <img src="/icons/arrow_right_gray.png" alt="arrow" width={20} height={20} />
          </a>
        </div>
        <Checkbox
          label="동의"
          checked={checkedList[index]}
          onClick={(e) => {
            e.preventDefault();
            toggleChecked(index);
          }}
        />
      </div>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? 8 : 20,
        alignItems: 'flex-start',
        padding: '18px 0',
        borderTop: '1px solid #D5D5D5',
      }}
    >
      {isMobile ? (
        <>
          <CheckboxWrap />
          <StyledContents
            style={{
              marginTop: 8,
            }}
          >
            {termTextList[index]}
          </StyledContents>
        </>
      ) : (
        <>
          <StyledContents
            style={{
              width: 620,
            }}
          >
            {termTextList[index]}
          </StyledContents>
          <CheckboxWrap />
        </>
      )}
    </div>
  );
}

export const Checkbox = ({ label, checked, onClick, style, isMobile }) => {
  return (
    <StyledCheckboxWrap onClick={onClick} style={style} $isMobile={isMobile}>
      <img
        src={checked ? '/icons/checked_box.png' : '/icons/unchecked_box.png'}
        alt="체크박스"
        width={isMobile ? 20 : 24}
        height={isMobile ? 20 : 24}
      />
      {label}
    </StyledCheckboxWrap>
  );
};

const StyledContents = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
  color: ${MyColor.gray383838};
  white-space: pre-line;
`;

export const StyledLabel = styled.div`
  ${TextUtil.text14Normal}
  font-weight: 500;
  color: ${MyColor.gray80};
`;

const StyledCheckboxWrap = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px 12px 12px;
  border-radius: 8px;
  background-color: ${MyColor.gray10};
  ${TextUtil.text16Bold}
  font-weight: 500;
  color: ${MyColor.gray80};

  width: ${(props) => (props.$isMobile ? '100%' : 'auto')};
  box-sizing: border-box;
`;
